import { Col as BsCol } from "reactstrap";

const Col = (props: any) => {

  return <BsCol
    widths={['xs', 'sm', 'md', 'lg', 'xl', 'xxl', 'xxxl', 'xxxxl']}
    {...props} />
}

export default Col;